import Toggle from './Toggle.component';
import LabelToggle from './LabelToggle/LabelToggle.component';
import Checkbox from '../Checkbox';

Toggle.Label = LabelToggle;
Toggle.Checkbox = Checkbox;

export default Toggle;
